/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CopilotUserMetricsResponse {
    getFixupPrototypeFunction() { return CopilotUserMetricsResponse.fixupPrototype; }

    static newInstance(model: Partial<CopilotUserMetricsResponse>): CopilotUserMetricsResponse {
        let obj = Object.assign(new CopilotUserMetricsResponse(), model);
        CopilotUserMetricsResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CopilotUserMetricsResponse>): CopilotUserMetricsResponse {
        if (!model) return null;
        return CopilotUserMetricsResponse.newInstance(<CopilotUserMetricsResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CopilotUserMetricsResponse) {
        if (!obj) return;

        models.CopilotUserMetricsResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CopilotUserMetricsResponse): boolean {
        Object.setPrototypeOf(obj, CopilotUserMetricsResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.user_metrics) {
            for (let val of this.user_metrics) {
                models.CopilotUserMetric.fixupPrototype(val);
            }
        }
    }

    /**
     * Per-user Copilot usage metrics
     */
    user_metrics: Array<models.CopilotUserMetric>;

}
